import '../styles/pages/ServiceOne.scss';
import service1 from '../assets/icons/service1.svg';
import service2 from '../assets/icons/service2.svg';
import service3 from '../assets/icons/service3.svg';
import service4 from '../assets/icons/service4.svg';
import serviceOneBanner from '../assets/service1.svg'
import serviceOneBannerMobile from '../assets/phone/creation.svg'
import bannerBG2 from '../assets/banner-bg2.svg';
import { useState } from 'react';
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { useTranslation } from 'react-i18next';

const ServiceOne = () => {
    const { t } = useTranslation();
    const servicesDisplayCount = window.innerWidth > 768 ? 4 : 1
    const [currentIndex, setCurrentIndex] = useState(0);
    const services = [
        {
            img: service1,
            title: t('home.services.suarl.title'),
            subtitle: t('home.services.suarl.subtitle'),
            description: t('home.services.suarl.description'),
        },
        {
            img: service2,
            title: t('home.services.sarl.title'),
            subtitle: t('home.services.sarl.subtitle'),
            description: t('home.services.sarl.description'),
        },
        {
            img: service3,
            title: t('home.services.sa.title'),
            subtitle: t('home.services.sa.subtitle'),
            description: t('home.services.sa.description'),
        },
        {
            img: service4,
            title: t('home.services.offshore.title'),
            subtitle: t('home.services.offshore.subtitle'),
            description: t('home.services.offshore.description'),
        },
    ];
    return(
        <div className='main-container'>
            <div className='cr-header'>
                <h1> {t('serviceOne.header')} </h1>
            </div>
            <div className='cr-intro'>
                <ul>
                    <li> {t('serviceOne.intro.p1')} </li>
                    <li> {t('serviceOne.intro.p2')} </li>
                </ul>
                <div className='cr-intro-image'>
                    <img src={window.innerWidth > 768 ? serviceOneBanner : serviceOneBannerMobile} alt="Création d'entreprise" className='img-banner' />
                    <img src={bannerBG2} alt='background 2' className='background2' />
                </div> 
            </div>
            <div className='cr-steps-container'>
                <div className='cr-steps-title'>
                    <h2> {t('serviceOne.steps.title')} <span className='colored'>{t('serviceOne.steps.colored')}</span> </h2>
                </div>
                <div className='cr-steps'>
                    <div className="step">
                        <div className='step-title'><span>{t('serviceOne.steps.step1.number')}</span> <h3> {t('serviceOne.steps.step1.title')} </h3></div>
                        <ul>
                            <li> {t('serviceOne.steps.step1.l1')} </li>
                            <li> {t('serviceOne.steps.step1.l2')} </li>
                            <li> {t('serviceOne.steps.step1.l3')} </li>
                        </ul>
                    </div>
                    <div className="step">
                        <div className='step-title'><span>{t('serviceOne.steps.step2.number')}</span> <h3> {t('serviceOne.steps.step2.title')} </h3></div>
                        <ul>
                            <li> {t('serviceOne.steps.step2.l1')} </li>
                            <li> {t('serviceOne.steps.step2.l2')} </li>
                            <li> {t('serviceOne.steps.step2.l3')} </li>
                        </ul>
                    </div>
                    <div className="step">
                        <div className='step-title'><span>{t('serviceOne.steps.step3.number')}</span> <h3> {t('serviceOne.steps.step3.title')} </h3></div>
                        <ul>
                            <li> {t('serviceOne.steps.step3.l1')} </li>
                            <li> {t('serviceOne.steps.step3.l2')} </li>
                            <li> {t('serviceOne.steps.step3.l3')} </li>
                        </ul>
                    </div>
                    <div className="step">
                        <div className='step-title'><span>{t('serviceOne.steps.step4.number')}</span> <h3> {t('serviceOne.steps.step4.title')} </h3></div>
                        <ul>
                            <li> {t('serviceOne.steps.step4.l1')} </li>
                            <li> {t('serviceOne.steps.step4.l2')} </li>
                            <li> {t('serviceOne.steps.step4.l3')} </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='cr-services-container'>
                <h2> {t('serviceOne.services.title')} <span className='colored'>{t('serviceOne.services.colored')}</span> </h2>
                <div className='services'>
                    <button onClick={() => setCurrentIndex(prev => (prev === 0 ? services.length - servicesDisplayCount : prev - 1))}>
                        <IoChevronBackOutline />
                    </button>
                    {services
                        .slice(currentIndex, currentIndex + servicesDisplayCount)
                        .map((service, index) => (
                        <div className='service-card' key={index}>
                            <img src={service.img} alt={service.title} />
                            <h3>{service.title}</h3>
                            {service.subtitle && <span>{service.subtitle}</span>}
                            <p>{service.description}</p>
                        </div>
                    ))}
                    <button onClick={() => setCurrentIndex(prev => (prev + 1) % (services.length - servicesDisplayCount + 1))}>
                        <IoChevronForwardOutline />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ServiceOne;
